class ImageContainerResizer {
  constructor() {
    this.updateImageContainerHeight = this.updateImageContainerHeight.bind(this); // Bind context
    this.handleImageLoad = this.handleImageLoad.bind(this);

    this.boundImages = new Set();
    this.bindImageLoadEvents();
    this.updateImageContainerHeight(); // Initial update

    window.addEventListener("resize", this.updateImageContainerHeight);
    window.addEventListener("orientationchange", this.updateImageContainerHeight);
  }

  bindImageLoadEvents() {
    const images = document.querySelectorAll('.lc-infobox__image');

    images.forEach(image => {
      if (this.boundImages.has(image)) {
        return;
      }

      this.boundImages.add(image);

      if (!image.complete) {
        image.addEventListener("load", this.handleImageLoad);
      }
    });
  }

  handleImageLoad() {
    this.updateImageContainerHeight();
  }

  updateImageContainerHeight() {
    this.bindImageLoadEvents();

    const images = document.querySelectorAll('.lc-infobox__image');

    images.forEach(image => {
      const container = image.closest(".lc-infobox__col--image");
      if (image && container) {
        const imageHeight = image.getBoundingClientRect().height;

        if (imageHeight > 0) {
          container.style.height = `${imageHeight}px`;
        } else {
          container.style.height = "";
        }
      }
    });
  }

  unsubscribe() {
    this.boundImages.forEach(image => {
      image.removeEventListener("load", this.handleImageLoad);
    });

    this.boundImages.clear();

    window.removeEventListener("resize", this.updateImageContainerHeight);
    window.removeEventListener("orientationchange", this.updateImageContainerHeight);
  }
}

export default ImageContainerResizer;
